<template>
    <div>
        <div>
            <el-form size="mini" label-width="90px" label-position="right">
                <el-form-item label="关卡类型：">
                    <el-select v-model="selectedLevelType" placeholder="请选择关卡类型" @change="onSelectedLevelTypeChange">
                        <el-option v-for="item in levelTypeSelectorOptions" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <el-table :data="tableRows" border size="small" max-height="400px" style="width: 631px"
                v-el-table-infinite-scroll="loadMoreTableRows" :infinite-scroll-disabled="tableRows.length == 0"
                @sort-change="onTableSortColumnChange">
                <el-table-column prop="levelType" label="关卡类型" align="center" width="150" show-overflow-tooltip>
                </el-table-column>

                <el-table-column prop="levelId" label="关卡ID" align="center" width="120" sortable="custom">
                </el-table-column>

                <el-table-column prop="passRate" align="center" width="100" sortable="custom">
                    <template slot="header">
                        <span>通关率</span>
                        <div>
                            <el-tooltip effect="dark" placement="top">
                                <div slot="content">=通关人数/累计挑战次数</div>
                                <span><i class="el-icon-question" style="font-size: 1.2em"></i></span>
                            </el-tooltip>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <span>{{ `${(100 * scope.row.passRate).toFixed(2)}%` }}</span>
                    </template>
                </el-table-column>

                <el-table-column prop="passedPlayers" label="通关人数" align="center" width="100">
                </el-table-column>

                <el-table-column prop="challengedTimes" align="center" width="160">
                    <template slot="header">
                        <span>通关时已挑战次数</span>
                        <div>
                            <el-tooltip effect="dark" placement="top">
                                <div slot="content">所有通关玩家从首次挑战至首次通关的累计已挑战次数</div>
                                <span><i class="el-icon-question" style="font-size: 1.2em"></i></span>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
    data() {
        return {
            levelTypeSelectorOptions: [],
            selectedLevelType: "",
            sortField: "", // 这个值是数据库字段名
            sortOrder: 1, // 升序：1，降序：-1

            tableRows: [],
            tablePageSize: 20,
        };
    },

    async created() {
        this.sortField = "level_id";

        await this.loadAllLevelTypes();

        if (this.levelTypeSelectorOptions && this.levelTypeSelectorOptions.length > 0) {
            this.selectedLevelType = this.levelTypeSelectorOptions[0].value;
        }

        await this.loadTableRows(0, this.tablePageSize);
    },

    methods: {
        onSelectedLevelTypeChange() {
            // 清空表格，重新查询
            this.tableRows = [];
            this.loadTableRows(0, this.tablePageSize);
        },

        onTableSortColumnChange(metadata) {
            //console.log("onTableSortColumnChange(), metadata:", metadata)
            if (metadata.prop == "levelId") {
                this.sortField = "level_id";
            } else if (metadata.prop == "passRate") {
                this.sortField = "pass_rate";
            }

            this.sortOrder = metadata.order == "ascending" ? 1 : -1;

            // 清空表格，重新查询
            this.tableRows = [];
            this.loadTableRows(0, this.tablePageSize);
        },

        loadMoreTableRows() {
            this.loadTableRows(this.tableRows.length, this.tablePageSize);
        },

        async loadAllLevelTypes() {
            let resData = (
                await axios.post(
                    `${util.getBackendApiBase()}/v1/admin/queryAllLevelTypesOfLevelPassRates`,
                    {},
                    {
                        headers: {
                            token: bizutil.getLoginUserToken(),
                        },
                    }
                )
            ).data;
            if (resData.code > 0) {
                this.$message.error(resData.message);
                return;
            }

            if (resData.data.levelTypes) {
                for (let e of resData.data.levelTypes) {
                    this.levelTypeSelectorOptions.push({
                        label: e,
                        value: e,
                    });
                }
            }
        },

        async loadTableRows(offset, limit) {
            if (offset == 0) {
                this.tableRows = [];
            }

            let resData = (
                await axios.post(
                    `${util.getBackendApiBase()}/v1/admin/queryLevelPassRates`,
                    {
                        levelType: this.selectedLevelType,
                        sortField: this.sortField,
                        sortOrder: this.sortOrder,
                        offset: offset,
                        limit: limit,
                    },
                    {
                        headers: {
                            token: bizutil.getLoginUserToken(),
                        },
                    }
                )
            ).data;
            if (resData.code > 0) {
                this.$message.error(resData.message);
                return;
            }

            let listInResponse = resData.data.entries || [];
            this.tableRows = this.tableRows.concat(listInResponse);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table__row td {
    padding: 3px 0;
}

::v-deep .el-table .cell {
    line-height: 18px;
}
</style>